// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
// @ helpers
const { raiseToN2 } = require('actions/contactCenter/raiseToN2/raiseToN2');

const setVisibleStep = (step) => (dispatch) => {
    dispatch({
        type: actionTypes.GAP_ACCESS_SET_VISIBLE_STEP,
        payload: {
            step
        }
    });
};

const setOperative = (operative) => (dispatch) => {
    dispatch({
        type: actionTypes.GAP_ACCESS_SET_OPERATIVE,
        payload: {
            operative
        }
    });
};

const gapSecurityDataFailure = () => ({
    type: actionTypes.GAP_SECURITY_DATA_ERROR,
});

const validateStep = (step) => (dispatch) => {
    dispatch({
        type: actionTypes.GAP_VALIDATE_STEP,
        payload: {
            step
        }
    });
};

const resetWizard = () => (dispatch) => {
    dispatch({
        type: actionTypes.GAP_RESET
    })
};

const handleFinish = () => (dispatch, getState) => {
    const immSignaturePattern = getState().signaturePattern;
    const consumerDigitsCompleted = immSignaturePattern.get('consumerFinishInputDigits');
    const isFetchingConfigError = immSignaturePattern.get('isFetchingConfigError');

    if(isFetchingConfigError) {
        return;
    }
    if(consumerDigitsCompleted) {
        raiseToN2(dispatch, getState);
    }
    else {
        dispatch(gapSecurityDataFailure());
    }
}

module.exports = {
    setVisibleStep,
    validateStep,
    setOperative,
    resetWizard,
    handleFinish,
}
